// http://stackoverflow.com/questions/123999
// Checks if an element is visible in the current viewport. Elements that have not yet scrolled into the window are considered not visible.
export function isElementVisibleInViewport(el) {
    var eap,
        rect     = el.getBoundingClientRect(),
        docEl    = document.documentElement,
        vWidth   = window.innerWidth || docEl.clientWidth,
        vHeight  = window.innerHeight || docEl.clientHeight,
        efp      = function (x, y) { return document.elementFromPoint(x, y) },
        contains = "contains" in el ? "contains" : "compareDocumentPosition",
        has      = contains == "contains" ? 1 : 0x10;

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0
        || rect.left > vWidth || rect.top > vHeight)
        return false;

    // Return true if any of its four corners are visible
    return (
        (eap = efp(rect.left,  rect.top)) == el || el[contains](eap) == has
        ||  (eap = efp(rect.right, rect.top)) == el || el[contains](eap) == has
        ||  (eap = efp(rect.right, rect.bottom)) == el || el[contains](eap) == has
        ||  (eap = efp(rect.left,  rect.bottom)) == el || el[contains](eap) == has
    );
}

export function isElementPartiallyInViewport(el)
{
    //special bonus for those using jQuery
    if (typeof jQuery !== 'undefined' && el instanceof jQuery) el = el[0];

    var rect = el.getBoundingClientRect();
    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
}


// Checks if the element is displayed on the page (even outside the viewport).
export function isElementDisplayedOnPage(el) {
    if (el == document) { return true; }
    if (!$(el).visible()) { return false; }
    return isElementDisplayedOnPage(el.parentNode);
}

export function getElementDocumentPosition(element) {
    let clientRect = element.getBoundingClientRect(); // Get position relative to the viewport.
    const scrollPosition = getDocumentScrollPosition();
    return {
        left: clientRect.left + scrollPosition.left,
        top: clientRect.top + scrollPosition.top
    };
}

export function getDocumentScrollPosition() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    return { top: scrollTop, left: scrollLeft };
}

export function cumulativeOffset(element) {
    let valueT = 0, valueL = 0;
    if (element.parentNode) {
        do {
            valueT += element.offsetTop  || 0;
            valueL += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);
    }
    return { top: Math.round(valueT), left: Math.round(valueL) };
}
